import Vue from "vue";
import { InsuranceService } from "@/services/api.service";
import { FETCH_INSURANCE, VARIFIED_CARD } from "./actions.type";
import { RESET_STATE, SET_INSURANCE } from "./mutations.type";

const initialState = {
  insurance: []
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_INSURANCE](context, slug) {
    const { data } = await InsuranceService.get(slug);
    context.commit(SET_INSURANCE, data);
    return data;
  },
  [RESET_STATE]({ commit }) {
    commit(RESET_STATE);
  },
  async [VARIFIED_CARD](context, payload) {
    //console.log(payload)
    const { data } = await InsuranceService.post(payload.slug, payload.data);
    return data;
  }
};
export const mutations = {
  [SET_INSURANCE](state, insurance) {
    state.insurance = insurance;
  },
  [RESET_STATE]() {
    for (let f in state) {
      Vue.set(state, f, initialState[f]);
    }
  }
};

export const getters = {
  insurance(state) {
    return state.insurance;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
